// Deep import, not the barrel: this entry chunk is deliberately lean (even
// ./bootstrap is a dynamic import), and the `@heartplus/ui` barrel would pull
// the whole design system into it.
import { reserveEnvironmentBannerSpace } from '@heartplus/ui/components/ui/environment-banner/reserve-environment-banner-space';

import env from '@/config/env';
import { initOpenReplay } from '@/features/tracker/openreplay';
import { isLocalhostHostname } from '@/utils/hostname';

// Dev tools (react-scan/react-grab) are ON by default in local dev. They add
// noticeable per-render overhead, so allow opt-OUT via env or localStorage:
//   VITE_DISABLE_DEV_TOOLS=true   (build/env)
//   localStorage.DISABLE_DEV_TOOLS = 'true'  (per-browser, no rebuild)
function areDevToolsDisabled(): boolean {
  if (import.meta.env['VITE_DISABLE_DEV_TOOLS'] === 'true') return true;
  try {
    return window.localStorage.getItem('DISABLE_DEV_TOOLS') === 'true';
  } catch {
    return false;
  }
}

async function startApp() {
  // Before anything renders: the banner's height drives the body margin and
  // every full-height shell, so publishing it mid-render would shift the whole
  // layout on first paint.
  reserveEnvironmentBannerSpace(env.isStaging());

  if (
    import.meta.env.DEV &&
    isLocalhostHostname(window.location.hostname) &&
    !areDevToolsDisabled()
  ) {
    const { scan } = await import('react-scan');
    scan({ enabled: true });
    void import('react-grab');
  }

  // Start OpenReplay before the React app bootstraps so the login flow and
  // early route activity are captured in the same session.
  initOpenReplay();

  await import('./bootstrap');
}

void startApp();
